<template>
  <button title="Share" v-tippy="{ placement: 'top' }" @click="showModal">
    <font-awesome-icon :icon="faMegaphone" />
  </button>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faMegaphone } from "@fortawesome/pro-light-svg-icons/faMegaphone";
import ShareActivityModal from "./share-activity-modal";
import { create } from "vue-modal-dialogs";

const showModal = create({
  component: ShareActivityModal,
  wrapper: "activity-summary",
});

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      faMegaphone,
    };
  },
  methods: {
    showModal() {
      showModal();
    },
  },
};
</script>



// WEBPACK FOOTER //
// share-activity-button.vue?1dedc731